export default __webpack_public_path__ + "static/media/profile_panel_surya.69867691.mp4";